// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './FilterLabel.style';

export class FilterLabel extends PureComponent {
    static propTypes = {
        label: this.propTypes,
        children: this.propTypes,
        expandablecontemntclassname: this.propTypes
    };

    render() {
        const { label, expandablecontemntclassname, children } = this.props;

        return (
            <div className="FilterLabel">
                <article className={(expandablecontemntclassname ? `${expandablecontemntclassname} ` : "") + `ExpandableContent ProductConfigurableAttributes-Expandable`}>
                    <div className="ExpandableContent-Button ProductConfigurableAttributes-ExpandableContentButton">
                        <div className="ExpandableContent-Heading ProductConfigurableAttributes-ExpandableContentHeading">
                            {label && <span>{label}</span>}
                        </div>
                    </div>
                    <div className='ExpandableContent-Content ProductConfigurableAttributes-ExpandableContentContent'>
                        <div className="ProductConfigurableAttributes-SwatchList">
                            {children}
                        </div>
                    </div>
                </article>
            </div>
        );
    }
}

export default FilterLabel;
